import { useMemo } from 'react';

import { QuickQuoteResponseQuote } from 'lib/api/getQuickQuote';
import { Undef } from 'types/UtilityTypes';

import { InsightsCard } from './InsightsCard';
import { Suggestion } from './types';
import {
  findCoachQuote,
  mapSuggestionFromQuote,
} from './utils/mapSuggestionFromQuote';

type QuickQuoteCoachProps = {
  quotes: Undef<QuickQuoteResponseQuote[]>;
  selected: boolean;
  onSelect: (suggestion: Suggestion) => void;
  isCalculationStepsOpen?: boolean;
};

export function QuickQuoteCoach({
  quotes,
  selected,
  onSelect,
  isCalculationStepsOpen,
}: QuickQuoteCoachProps) {
  const suggestion = useMemo(
    () => mapSuggestionFromQuote(findCoachQuote(quotes)),
    [quotes]
  );

  if (!suggestion) {
    return null;
  }

  return (
    <InsightsCard
      suggestion={suggestion}
      selected={selected}
      onSelect={() => onSelect(suggestion)}
      isCalculationStepsOpen={isCalculationStepsOpen}
    />
  );
}
